export const navLinks = [
  { label: '首页', href: '/' },
  { label: '韩漫排行', href: '/category/all' },
  { label: '免费漫画', href: '/category/all' },
  { label: '漫画分类', href: '/category/all' },
  { label: '关于我们', href: '/about' },
];

export const categories = [
  {
    id: 'korean-romance',
    name: '韩漫恋爱',
    nameEn: 'Korean Romance',
    description: '甜蜜浪漫的韩国恋爱漫画，讲述动人的爱情故事',
    icon: 'ri-heart-line',
    count: 3268,
    slug: 'korean-romance',
  },
  {
    id: 'korean-action',
    name: '热血格斗',
    nameEn: 'Action & Fighting',
    description: '拳拳到肉的热血格斗漫画，感受极致打击快感',
    icon: 'ri-sword-line',
    count: 2156,
    slug: 'korean-action',
  },
  {
    id: 'korean-fantasy',
    name: '奇幻冒险',
    nameEn: 'Fantasy Adventure',
    description: '穿越异世界的奇幻旅程，开启不可思议的冒险',
    icon: 'ri-rocket-line',
    count: 1892,
    slug: 'korean-fantasy',
  },
  {
    id: 'korean-thriller',
    name: '悬疑惊悚',
    nameEn: 'Thriller & Mystery',
    description: '扣人心弦的悬疑故事，层层反转让你欲罢不能',
    icon: 'ri-ghost-line',
    count: 1437,
    slug: 'korean-thriller',
  },
  {
    id: 'korean-comedy',
    name: '搞笑日常',
    nameEn: 'Comedy & Slice of Life',
    description: '轻松搞笑的日常漫画，每天十分钟治愈你的心情',
    icon: 'ri-emotion-laugh-line',
    count: 2103,
    slug: 'korean-comedy',
  },
  {
    id: 'korean-drama',
    name: '都市剧情',
    nameEn: 'Urban Drama',
    description: '现实向都市剧情漫画，职场、家庭、人生百态',
    icon: 'ri-building-line',
    count: 1678,
    slug: 'korean-drama',
  },
];

export const popularComics = [
  {
    id: 1,
    title: '绝世神医',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20handsome%20male%20doctor%20in%20traditional%20hanbok%20with%20golden%20acupuncture%20needles%2C%20mystical%20ancient%20Korean%20palace%20background%2C%20dramatic%20lighting%2C%20vibrant%20colors%2C%20clean%20illustration%20style%2C%20soft%20gradient%20background&width=800&height=1120&seq=comic-cover-01&orientation=portrait',
    rating: 9.8,
    views: '1,286万',
    latestChapter: '第128话',
    updateTime: '2小时前',
    tags: ['医疗', '古风', '热血'],
    rank: 1,
    category: 'korean-action',
    summary: '精通医术的少年在古代王朝中闯出一片天，用神奇的针灸术治愈疑难杂症，同时卷入宫廷权力斗争。',
    status: '连载中',
    publishYear: 2023,
  },
  {
    id: 2,
    title: '我独自升级',
    author: 'Chugong',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20dark%20fantasy%20hunter%20with%20glowing%20purple%20eyes%20in%20black%20armor%2C%20shadow%20army%20behind%20him%2C%20dungeon%20portal%20background%2C%20epic%20atmosphere%2C%20clean%20manga%20illustration%20style&width=800&height=1120&seq=comic-cover-02&orientation=portrait',
    rating: 9.7,
    views: '2,563万',
    latestChapter: '第179话',
    updateTime: '昨天',
    tags: ['奇幻', '升级', '热血'],
    rank: 2,
    category: 'korean-fantasy',
    summary: '最弱的猎人获得系统后一路逆袭，成为暗影君主统治地下城的传奇故事。',
    status: '连载中',
    publishYear: 2022,
  },
  {
    id: 3,
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20beautiful%20girl%20with%20long%20hair%20and%20natural%20makeup%20transformation%2C%20soft%20pastel%20color%20palette%2C%20cherry%20blossom%20petals%2C%20school%20uniform%2C%20romantic%20atmosphere%2C%20clean%20illustration&width=800&height=1120&seq=comic-cover-03&orientation=portrait',
    rating: 9.5,
    views: '3,892万',
    latestChapter: '第256话',
    updateTime: '3天前',
    tags: ['恋爱', '校园', '美妆'],
    rank: 3,
    category: 'korean-romance',
    summary: '平凡女孩通过化妆变身为校园女神，在两个帅气男生之间展开甜蜜又纠结的青春恋爱故事。',
    status: '连载中',
    publishYear: 2021,
  },
];

export const recommendedComics = [
  {
    id: 4,
    title: '全知读者视角',
    author: 'sing N song',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20young%20man%20holding%20a%20glowing%20book%20in%20apocalyptic%20setting%2C%20constellation%20stars%20in%20sky%2C%20dramatic%20composition%2C%20vibrant%20colors%2C%20clean%20illustration%20style&width=800&height=1120&seq=comic-cover-04&orientation=portrait',
    latestChapter: '第210话',
    rating: 9.6,
    description: '唯一读完末日小说的人，世界变成了书中的模样',
    tags: ['奇幻', '末世', '智斗'],
    category: 'korean-fantasy',
    summary: '当全世界变成一部小说时，唯一读完整部作品的读者成为了改变命运的关键人物。',
    status: '连载中',
    publishYear: 2022,
    views: '1,876万',
    updateTime: '昨天',
    featured: true,
  },
  {
    id: 5,
    title: '剑尊归来',
    author: 'LIAN',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20murim%20manhwa%20cover%2C%20swordsman%20in%20traditional%20martial%20arts%20robe%20with%20long%20sword%2C%20mountain%20peak%20background%20with%20moon%2C%20ink%20wash%20painting%20style%20inspired%2C%20clean%20illustration&width=800&height=1120&seq=comic-cover-05&orientation=portrait',
    latestChapter: '第156话',
    rating: 9.4,
    description: '天下第一剑回归，誓要重振师门昔日荣光',
    tags: ['武侠', '回归', '热血'],
    category: 'korean-action',
    summary: '武林最强剑客被背叛身亡，千年后以现代人身份重生，誓要夺回失去的一切。',
    status: '连载中',
    publishYear: 2022,
    views: '987万',
    updateTime: '5小时前',
    featured: false,
  },
  {
    id: 6,
    title: '僵尸校园',
    author: '朱东根',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20zombie%20thriller%20manhwa%20cover%2C%20students%20running%20in%20dark%20school%20hallway%2C%20zombie%20silhouettes%20behind%2C%20tense%20atmosphere%2C%20emergency%20red%20lighting%2C%20clean%20illustration%20style&width=800&height=1120&seq=comic-cover-06&orientation=portrait',
    latestChapter: '第134话',
    rating: 9.3,
    description: '校园爆发丧尸病毒，学生们绝境求生的惊险故事',
    tags: ['惊悚', '校园', '生存'],
    category: 'korean-thriller',
    summary: '高中校园突然爆发丧尸病毒，学生们在绝望中展开惊险的生存冒险。',
    status: '连载中',
    publishYear: 2023,
    views: '2,134万',
    updateTime: '昨天',
    featured: false,
  },
  {
    id: 7,
    title: '恋爱革命',
    author: '232',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%2C%20shy%20chubby%20boy%20with%20transformation%20to%20handsome%20teen%2C%20split%20personality%20design%2C%20pink%20and%20white%20color%20scheme%2C%20school%20background%2C%20heart%20elements%2C%20clean%20modern%20illustration&width=800&height=1120&seq=comic-cover-07&orientation=portrait',
    latestChapter: '第421话',
    rating: 9.6,
    description: '普通高中生开启恋爱逆袭之路',
    tags: ['恋爱', '校园', '逆袭'],
    category: 'korean-romance',
    summary: '一个普通高中生通过努力改变形象，最终追到校花的女神之路。',
    status: '连载中',
    publishYear: 2019,
    views: '5,621万',
    updateTime: '2小时前',
    featured: false,
  },
  {
    id: 8,
    title: '搞笑一家人',
    author: '朴钟旭',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20slice%20of%20life%20manhwa%20cover%2C%20colorful%20family%20portrait%20with%20different%20expressions%2C%20warm%20bright%20colors%2C%20living%20room%20background%2C%20funny%20expressions%2C%20cartoon%20style%2C%20clean%20illustration&width=800&height=1120&seq=comic-cover-08&orientation=portrait',
    latestChapter: '第318话',
    rating: 9.2,
    description: '温馨搞笑的家庭日常，笑点不断',
    tags: ['搞笑', '日常', '家庭'],
    category: 'korean-comedy',
    summary: '三代同堂的温馨家庭，每天都有让人捧腹大笑的日常趣事。',
    status: '连载中',
    publishYear: 2020,
    views: '1,432万',
    updateTime: '6小时前',
    featured: false,
  },
  {
    id: 9,
    title: '梨泰院',
    author: '金尚旭',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20urban%20drama%20manhwa%20cover%2C%20stylish%20young%20man%20in%20modern%20urban%20setting%20with%20neon%20lights%2C%20city%20nightscape%20background%2C%20ambitious%20attitude%2C%20trendy%20fashion%2C%20warm%20color%20palette%2C%20clean%20illustration&width=800&height=1120&seq=comic-cover-09&orientation=portrait',
    latestChapter: '第87话',
    rating: 9.1,
    description: '梨泰院商业街的野心与复仇故事',
    tags: ['都市', '商战', '复仇'],
    category: 'korean-drama',
    summary: '一个年轻人怀揣复仇之心来到梨泰院，凭借智慧和勇气在商战中一路崛起。',
    status: '连载中',
    publishYear: 2023,
    views: '876万',
    updateTime: '昨天',
    featured: false,
  },
];

export const testimonials = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20simple%20background%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-01&orientation=squarish',
    role: '资深漫友 · 3年',
    rating: 5,
    title: '下拉式阅读体验太棒了',
    content: '之前一直用其他平台看漫画，翻页加载很慢。土豪漫画的下拉式阅读真的超级流畅，一口气能看几十话，韩漫资源也很全，强烈推荐！',
  },
  {
    id: 2,
    name: '追漫少女小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20warm%20smile%2C%20natural%20makeup%2C%20simple%20background%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-02&orientation=squarish',
    role: '韩漫爱好者 · 2年',
    rating: 5,
    title: '人气榜更新超及时',
    content: '人气榜真的很准！每次新出的热门韩漫都能第一时间在榜单上看到，再也不用自己去到处找了，更新速度也非常快。',
  },
  {
    id: 3,
    name: '二次元阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20stylish%20haircut%2C%20confident%20expression%2C%20simple%20background%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-03&orientation=squarish',
    role: '漫画博主 · 5年',
    rating: 5,
    title: '画质高清，加载飞快',
    content: '做漫画推荐博主好几年了，土豪漫画的画质真的没得说，高清模式看细节特别清楚。而且完全免费，良心平台！',
  },
  {
    id: 4,
    name: '上班族小林',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20professional%20look%2C%20gentle%20smile%2C%20simple%20background%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-04&orientation=squarish',
    role: '通勤追漫族 · 1年',
    rating: 4,
    title: '通勤路上必备神器',
    content: '每天地铁上都要看几话，分类很清晰，找漫画特别方便。下拉模式单手操作也很友好，已经成为我的日常必备了。',
  },
  {
    id: 5,
    name: '学生党小张',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20student%20portrait%2C%20glasses%2C%20friendly%20expression%2C%20simple%20background%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-05&orientation=squarish',
    role: '大学生 · 2年',
    rating: 5,
    title: '免费又全面，学生党福音',
    content: '作为学生预算有限，土豪漫画完全免费真的太友好了！而且漫画种类齐全，日漫韩漫国漫都有，宿舍四个人都在用。',
  },
  {
    id: 6,
    name: '夜猫子阿文',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20casual%20style%2C%20relaxed%20expression%2C%20simple%20background%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-06&orientation=squarish',
    role: '深夜追更党 · 4年',
    rating: 5,
    title: '熬夜追更根本停不下来',
    content: '每天晚上躺床上刷漫画已经成为习惯了，下拉式真的太适合在被窝里看了，不用频繁点屏幕，一滑到底。',
  },
];

export const statsData = {
  totalComics: 36000,
  dailyUpdates: 1280,
  registeredUsers: 8500000,
  totalViews: 12000000000,
};

export const faqData = [
  {
    question: '土豪漫画网真的免费吗？',
    answer: '是的！土豪漫画网所有漫画资源完全免费观看，无需注册会员或充值。我们致力于为漫画爱好者提供零门槛的优质阅读体验。',
  },
  {
    question: '下拉式阅读有什么优势？',
    answer: '下拉式阅读是我们首创的阅读模式，您只需向下滑动即可连续阅读，无需频繁点击翻页按钮。这种模式尤其适合手机端单手操作，阅读体验更加流畅自然。',
  },
  {
    question: '漫画更新频率如何？',
    answer: '我们每日更新超过1,280话漫画内容。热门连载作品基本同步韩国最新进度，人气榜数据每24小时实时刷新，确保您不会错过任何精彩内容。',
  },
  {
    question: '可以离线阅读吗？',
    answer: '目前我们提供在线阅读服务，暂不支持离线下载功能。建议在有网络连接的环境下浏览，以获得最佳的高清画质体验。',
  },
  {
    question: '如何联系客服？',
    answer: '您可以通过页脚的联系表单发送消息，或添加客服微信 tuhaomanhua_kefu 进行咨询。工作时间为周一至周日 9:00 - 22:00，我们会尽快为您解答。',
  },
  {
    question: '漫画加载慢怎么办？',
    answer: '建议您检查网络连接是否稳定，或尝试切换网络环境。如果问题持续存在，可以联系客服反馈，我们会优化相关漫画的资源服务器。',
  },
];